import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { Modules } from "../../../constants/Module";
import {
  commentCreate,
  deleteComment,
  getCommentList,
  showComment,
  updateComment,
} from "../../../api/casp/comment";
import { MemberIcon } from "../../../constants/MemberIcon";
import TextEditor from "../../../Components/casp/common/TextEditor";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import dayjs from "dayjs";
import { Action, DefaultPerPageValue } from "../../../constants/Common";
import InfiniteScroll from "react-infinite-scroll-component";
import Loader from "../../../Components/Common/Loader";
import UserProfile from "../../../Components/casp/common/userProfile";
import { withTranslation } from "react-i18next";

const CommentTab = ({ module, t }) => {
  const [editing, setEditing] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [update, setUpdate] = useState(0)
  const [hasMore, setHasMore] = useState(true);
  const [page, setPage] = useState(0);
  const [commentId, setCommentId] = useState();
  const [refreshComponentKeyComment, setRefreshComponentKeyComment] = useState({
    comment: +new Date() + 'comment',
    updateComment: +new Date() + 'updateComment'
  })
  const [commentsObject, setCommentsObject] = useState();
  const [comment, setComment] = useState();
  const params = useParams();
  const [queryParams, setQueryParams] = useState();
  const { user } = useSelector((state) => ({
    user: state.Profile.user,
  }));

  useEffect(() => {
    let query;
    switch (module) {
      case Modules.TICKET:
        query = {
          module: module,
          moduleId: parseInt(params.ticketId),
          projectId: parseInt(params.projectId),
        };
        setQueryParams(query);
    }
    getAllCommentForSpecificModule();
  }, []);

  const timeCalculate = (date) => {
    const currentDateTime = dayjs()
    const updatedDateTime = dayjs(date)
    const years = currentDateTime.diff(updatedDateTime, 'years');
    const months = currentDateTime.diff(updatedDateTime, 'months');
    const days = currentDateTime.diff(updatedDateTime, 'days');
    const hours = currentDateTime.diff(updatedDateTime, 'hours');
    const minutes = currentDateTime.diff(updatedDateTime, 'minutes');
    const seconds = currentDateTime.diff(updatedDateTime, 'seconds');

    if (years > 0 && years <= 2) {
      return `${years} year ago`
    } else if (months > 0 && months <= 12) {
      return `${months} month ago`
    } else if (days > 0 && days <= 31) {
      return `${days} days ago`
    } else if (hours > 0 && hours <= 24) {
      return hours === 1 ? `${hours} hour ago` : `${hours} hours ago`
    } else if (minutes > 0 && minutes < 60) {
      return minutes === 1 ? `${minutes} minute ago` : `${minutes} minutes ago`
    } else if (seconds > 0 && seconds < 60) {
      return seconds === 1 ? `${seconds} second ago` : `${seconds} seconds ago`
    } else if (seconds <= 0) {
      return 'just now'
    }

    return dayjs(date).format('ddd, MMM D, YYYY h:mm A');
  };

  const getAllCommentForSpecificModule = async (action) => {
    try {
      setIsLoading(true);
      const res = (await getCommentList({
        module: module,
        moduleId: parseInt(params.ticketId),
        projectId: parseInt(params.projectId),
        page: action === Action.CREATE ? 1 : page + 1,
        perPage: DefaultPerPageValue,
        order: 'updatedAt',
        direction: 'desc'
      })).data.data;

      setHasMore(res.meta.currentPage !== res.meta.lastPage);
      if (action === Action.CREATE) {
        setCommentsObject(res.data)
        setPage(1)
      } else {
        setCommentsObject((prevState) => {
          if (prevState !== undefined && prevState.length > 0) {
            return [...prevState, ...res.data]
          } else {
            return [...res.data]
          }
        });
        setPage((prevState) => prevState + 1);
      }
    } catch (error) {
      toast.error(error.message);
    } finally {
      setIsLoading(false);
    }
  };

  const handleCreateComment = async (comment) => {
    try {
      const payload = {
        ...comment,
        ...queryParams,
      };
      const res = await commentCreate(payload);
      if (res.statusCode === 200) {
        toast.success(res.data.message);
        setComment("");
        getAllCommentForSpecificModule(Action.CREATE)
      }
    } catch (error) {
      toast.error(error.message);
    }
  };

  const fetchCommentDetails = async (id = commentId, action) => {
    try {
      const res = await showComment(parseInt(id), queryParams);
      if (action === Action.CREATE) {
        setCommentsObject((prevState) => {
          if (prevState !== undefined && prevState.length > 0) {
            return [...prevState, { ...res.data.data }]
          } else {
            return [{ ...res.data.data }]
          }
        })
      } else {
        const result = commentsObject.map((item) => {
          if (item.id === commentId) {
            return {
              ...res.data.data,
            };
          } else {
            return {
              ...item,
            };
          }
        });
        setCommentsObject(result);
      }
    } catch (error) {
      toast.error(error.message);
    }
  };

  const handleEditComment = async (comment) => {
    try {
      const regex = /(<([^>]+)>)/gi;
      const newString = comment.comment.replace(regex, " ");
      if (!newString.toString().trim()) {
        setUpdate((prev) => prev + 1)
        return toast.error('comment is required');
      }
      const payload = {
        ...comment,
        ...queryParams,
      };
      const res = await updateComment(commentId, payload);
      toast.success(res.data.message);
      fetchCommentDetails();
    } catch (error) {
      toast.error(error.message);
    }
  };

  const handleEditClick = (id) => {
    setCommentId(id);
    if (editing && (commentId === id || commentId === undefined)) {
      setEditing(false);
    }
  };

  const closeTextArea = () => {
    setEditing(true);
  };

  const handleDelete = async (id) => {
    try {
      const res = await deleteComment(id, { ...queryParams });
      if (res.statusCode === 200) {
        toast.success(res.data.message);
        const result = commentsObject.filter((item) => item.id !== id)
        setCommentsObject(result);
        setPage(0)
      }
    } catch (error) {
      toast.error(error.message);
    }
  };

  useEffect(() => {
    const textareas = document.querySelectorAll(".commentTextarea");
    textareas.forEach((textarea) => {
      textarea.style.height = "auto"; // Reset height
      textarea.style.height = textarea.scrollHeight + "px"; // Set new height
    });
  }, [comment, editing]);

  return (
    <div className="d-flex flex-column allTabComment">
      <div className="singleCommentBox d-flex w-100 mb-3">
        <div>
        <UserProfile user={user} avatarClassName="me-2 ml-2" profileClassName="me-2 ml-2" />
        </div>
        <div className="flex-grow-1">
          <TextEditor
            key={refreshComponentKeyComment.comment}
            toolbarId={`toolbarCreateComment`}
            placeholder={t("Add Comment")}
            module={Modules.COMMENT}
            name="comment"
            isEmpty={comment ? false : true}
            handleEditClick={(value) => setEditing(value)}
            emitItem={(newValue) => {
              const regex = /(<([^>]+)>)/gi;
              const newString = newValue.replace(regex, "");
              if (!newString.toString().trim()) {
                return toast.error('comment is required');
              }
              else if(newString.trim().length !== newString.length) {
                setRefreshComponentKeyComment((prev) => {
                  return {...prev, comment: +new Date() + 'comment'}
                })
                return toast.error('Must not include leading and trailing spaces')
              }
              else {
                setComment(newValue);
                handleCreateComment({ comment: newValue });
              }
            }}
          />
        </div>
      </div>
      <InfiniteScroll
        dataLength={commentsObject ? commentsObject.length : 0}
        next={getAllCommentForSpecificModule}
        hasMore={hasMore}
        height={commentsObject?.length ? "450px" : "auto"}
        loader={isLoading && <Loader />}
      >
        {commentsObject &&
          commentsObject?.map((item) => (
            <div
              className={`singleCommentBox visible_comment d-flex w-100 mb-3 ${editing ? "desc_box" : commentId === item.id ? "" : "desc_box"
                }`}
              key={item.id}
            >
              <UserProfile user={item?.creator} avatarClassName="me-2 ml-2" profileClassName="me-2 ml-2" />
              <div className="d-flex flex-column w-100">
                <div className="flex-grow-1">
                  <h6 className="d-flex justify-content-between align-items-center">
                    <span className="personName">{item?.creator?.name}</span>
                    <span className="time">{timeCalculate(item.updatedAt)}</span>
                  </h6>
                  <div className="comment">
                    <TextEditor
                      key={refreshComponentKeyComment.updateComment}
                      toolbarId={`toolbarUpdate` + item.id}
                      content={item.comment}
                      disabled={editing}
                      module={Modules.COMMENT}
                      className={"visible_comment"}
                      commentId={commentId}
                      handleEditClick={(value) => setEditing(value)}
                      emitItem={(newValue) => {
                        const regex = /(<([^>]+)>)/gi;
                        const newString = newValue.replace(regex, "");
                        if (newString.trim().length !== newString.length) {
                          setRefreshComponentKeyComment((prev) => {
                            return {...prev, updateComment: +new Date() + 'updateComment'}
                          })
                          return toast.error('Must not include leading and trailing spaces')
                        }
                        handleEditComment({ comment: newValue });
                      }}
                    />
                  </div>
                </div>
                {editing && (
                  <ul className="list-inline d-flex my-2 align-items-center comment_actions">
                    <li onClick={(e) => handleEditClick(item.id)}>
                      {!editing && item.id === commentId ? t("Save") : t("Edit")}
                    </li>
                    <li
                      onClick={(e) =>
                        editing ? handleDelete(item.id) : closeTextArea()
                      }
                    >
                      {!editing && item.id === commentId ? t("Cancel") : t("Delete")}
                    </li>
                  </ul>
                )}
              </div>
            </div>
          ))}
      </InfiniteScroll>
    </div>
  );
};

export default withTranslation() (CommentTab);
